import { format, set } from 'date-fns';
import { jsx as _jsx } from "react/jsx-runtime";
export default function convertDateTimeHOC(WrappedComponent) {
  function ConvertDateTimeComponent({
    value,
    onChange,
    ...rest
  }) {
    return /*#__PURE__*/_jsx(WrappedComponent, {
      ...rest,
      value: value,
      onChange: date => {
        let newValue = new Date(date);
        if (value) {
          const [hour, minute] = format(new Date(value), 'HH:mm').split(':');
          newValue = set(new Date(date), {
            hours: Number(hour),
            minutes: Number(minute),
            seconds: 0,
            milliseconds: 0
          });
        } else {
          newValue = set(new Date(date), {
            hours: 0,
            minutes: 0,
            seconds: 0,
            milliseconds: 0
          });
        }
        onChange(newValue.toISOString());
      }
    });
  }
  return ConvertDateTimeComponent;
}